import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { DettaglioAdempimentoComponent } from './dettaglio-adempimento.component';
import { SezioneScadenze } from 'src/app/common/models/sezioni/sezione-scadenze';
import { Scadenza } from 'src/app/common/models/scadenza';
import { DettaglioAdempimento } from 'src/app/common/models/dettaglio-adempimento';


declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: 'dettaglio-adempimento-mod',
  templateUrl: 'dettaglio-adempimento-mod.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class DettaglioAdempimentoMod {
  @Output() onReturn: EventEmitter<SezioneScadenze> = new EventEmitter<SezioneScadenze>();
  @ViewChild('formDettaglioAdempimento') formDettaglioAdempimento: DettaglioAdempimentoComponent;

  inizializza(sezione: SezioneScadenze, idScadenza: string, urlUpdate: string, fascicolo: FascicoloFull, inserimento: boolean, dettaglio?: DettaglioAdempimento) {
    this.formDettaglioAdempimento.inizializza(sezione, idScadenza, urlUpdate, fascicolo, inserimento, dettaglio);
     openModal('modalDettaglioAdempimento');
  }

  createForm() { 
    this.formDettaglioAdempimento.createForm();
  }

  manageModal(sezione: SezioneScadenze) {
    closeModal('modalDettaglioAdempimento');
    this.onReturn.emit(sezione);
  }

}